import { useTranslation } from '@eti/providers';
import SubPage from './SubPage';

const TrustedChoicePage = () => {
  const { t } = useTranslation();

  return (
    <SubPage
      image="content/cookies"
      pageTitle={t('PageTitle.rf.trusted-choice.action')}
      textKey="TrustedChoice.HtmlContent"
    />
  );
};

export default TrustedChoicePage;
